import { branch, ComponentEnhancer, compose } from 'recompose';
import { RouteMatcher } from '../../RouteHelpers';
import { RouteComponentProps, withRouter } from 'react-router';
import { withoutRouter } from '../withoutRouter';

export const ifNonEmptyRoute = (...componentEnhancers: ComponentEnhancer<any, any>[]) =>
  compose(
    withRouter,
    branch<RouteComponentProps>(
      ({ location }) => !RouteMatcher.isEmpty(location.pathname),
      compose(...componentEnhancers),
    ),
    withoutRouter,
  );
